import apiClient from './apiClient';

export async function fetchEmailStats() {
  const { data } = await apiClient.get('/email/messages');
  const today = new Date().toISOString().slice(0, 10);
  const rows = data.filter((m) => String(m.received_at || m.created_at).slice(0, 10) === today);
  return {
    scannedToday: rows.length,
    blockedToday: rows.filter((m) => !['CLEAN', 'SUSPICIOUS'].includes(m.verdict)).length,
    phishingCaught: rows.filter((m) => m.verdict === 'PHISHING').length,
    malwareAttachments: rows.filter((m) => m.verdict === 'MALICIOUS' && m.attachment_count > 0).length,
    spoofAttempts: rows.filter((m) => ['FAIL', 'SOFTFAIL'].includes(m.dmarc_result)).length
  };
}

export async function fetchDomainAuth() {
  const { data } = await apiClient.get('/email/messages');
  const domains = new Map();
  data.forEach((m) => {
    const domain = String(m.recipient || '').split('@')[1];
    if (domain && !domains.has(domain)) domains.set(domain, {
      domain, spf: String(m.spf_result).toLowerCase(), dkim: String(m.dkim_result).toLowerCase(),
      dmarc: m.dmarc_result === 'PASS' ? 'enforced' : m.dmarc_result === 'NONE' ? 'none' : String(m.dmarc_result).toLowerCase()
    });
  });
  return [...domains.values()];
}

export async function fetchEmailThreats() {
  const { data } = await apiClient.get('/email/messages');
  return data.filter((m) => m.verdict !== 'CLEAN').map((m) => ({
    id: m.id, subject: m.subject || '(no subject)', from: m.sender,
    type: String(m.verdict).replaceAll('_', ' '),
    severity: m.risk_score >= 80 ? 'critical' : m.risk_score >= 60 ? 'high' : m.risk_score >= 30 ? 'medium' : 'low',
    action: ['MALICIOUS', 'PHISHING'].includes(m.verdict) ? 'blocked' : 'quarantined',
    timestamp: m.received_at
  }));
}

export async function fetchEmailFindings() {
  const { data } = await apiClient.get('/email/findings');
  return data;
}

export async function updateFindingStatus(id, status) {
  const { data } = await apiClient.patch(`/email/findings/${id}/status`, { status });
  return data;
}

export async function fetchRemediations() {
  const { data } = await apiClient.get('/email/remediations');
  return data;
}

export async function requestRemediation(payload) {
  const { data } = await apiClient.post('/email/remediations', {
    ...payload,
    idempotency_key: payload.idempotency_key || `${payload.message_id}-${payload.action}-${Date.now()}`,
  });
  return data;
}

export async function approveRemediation(id) {
  const { data } = await apiClient.post(`/email/remediations/${id}/approve`);
  return data;
}
